import { Component, ElementRef, OnInit, ViewChild, ɵConsole } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmComponent } from '../util/confirm/confirm.component';
import { ComentarioFormComponent } from '../comentario/comentario-form.component';
import { EstimativaAprovarFormComponent } from '../estimativa/estimativa-aprovar-form.component';
import { Subject } from 'rxjs';
import { Estimativa } from 'src/app/models/estimativa.model';
import { EstimativaService } from 'src/app/services/estimativa.service';
import { ValidacaoService } from 'src/app/services/validacao.service';
import { ProjetoService } from 'src/app/services/projeto.service';
import { UtilService } from 'src/app/services/util.service';
import { ComentarioService } from 'src/app/services/comentario.service';
import { Comentario } from 'src/app/models/comentario.model';
import { EquipeService } from 'src/app/services/equipe.service';
import * as html2pdf from 'html2pdf.js';
import * as constants from 'src/app/models/constants/constants';
import { UsuarioService } from 'src/app/services/usuario.service';

@Component({
  selector: 'app-price-estimativa-resumo.component',
  templateUrl: 'price-estimativa-resumo.component.html',
  styleUrls: ['./price-estimativa-resumo.component.scss'],
})
export class PriceEstimativaResumoComponent implements OnInit {
  @ViewChild('containerGeral') containerGeral: ElementRef<HTMLElement>;

  resetFormSubject: Subject<boolean> = new Subject<boolean>();
  estimativaId: number;
  nome: string;
  projetoId: number;
  projeto: string;
  crm: string;
  clienteNome: string;
  enviarAprovacao: boolean;
  mensagemValidacao: string;
  textoAprovar: string = 'Enviar Para Aprovação';
  podeEditar: boolean;
  estimativa: Estimativa;
  aprovarReprovar: boolean;
  isAdmin = false;
  user: any;
  totalEstimativa = 0;
  loading = false;
  estimativaTipo: any;
  qtdUser: any;
  usuarioLogin: any;
  statusEstimativa: string;
  estimativaTipoId: number;
  deliveryAdm: boolean;
  estimativaTipoDelivery: boolean;
  existeAnexo: boolean = false;
  existeComentario: boolean = false;

  imprimindoPDF = false;

  readonly TIPO_BODYSHOP = constants.TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_BODYSHOP;

  constructor(
    private usuarioService: UsuarioService,
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private estimativaService: EstimativaService,
    private validacaoService: ValidacaoService,
    private projetoService: ProjetoService,
    public utilService: UtilService,
    private comentarioService: ComentarioService,
    private dialog: MatDialog,
    private equipeService: EquipeService,
  ) {}

  ngOnInit() {
    // Pegando o ID passado pela URL
    this.estimativaId = this.activatedRouter.snapshot.params.id;
    this.isAdmin = this.utilService.isAdmin();
    if (this.isAdmin) {
      this.textoAprovar = 'Aprovar Proposta';
    }
    this.gerarEstimativas();

    this.estimativaService.getById(this.estimativaId).subscribe((estimativa) => {
      switch (estimativa.statusId) {
        case constants.EstimativaStatusConstants.ID_ESTIMATIVA_ELABORACAO:
          this.statusEstimativa = 'Em elaboração';
          break;
        case constants.EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA:
          this.statusEstimativa = 'Aprovada';
          break;
        case constants.EstimativaStatusConstants.ID_ESTIMATIVA_REPROVADA:
          this.statusEstimativa = 'Reprovada';
          break;
        case constants.EstimativaStatusConstants.ID_ESTIMATIVA_EM_APROVACAO:
          this.statusEstimativa = 'Em Aprovação';
          break;
        case constants.EstimativaStatusConstants.ID_ESTIMATIVA_DESCARTADA:
          this.statusEstimativa = 'Descartada';
          break;
      }

      this.estimativa = estimativa;
      this.estimativaTipoId = estimativa.estimativaTipoId;

      this.usuarioService.getById(this.estimativa.usuarioId).subscribe((result: any) => {
        this.usuarioLogin = result.login;
      });
    });

    this.getEstimativaTipo();
  }

  getEstimativaTipo() {
    this.estimativaService.getById(this.estimativaId).subscribe((result) => {
      this.estimativaTipoId = result.estimativaTipoId;

      this.estimativaTipoId !== constants.TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_BODYSHOP
        ? (this.deliveryAdm = true)
        : false;
      this.estimativaTipoId == constants.TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_DELIVERY
        ? (this.estimativaTipoDelivery = true)
        : false;
    });
  }

  exportarPdf() {
    this.imprimindoPDF = true;
    this.loading = true;

    const pdfName = `Pricing_${this.crm}_${this.clienteNome}_${this.projeto}_${this.nome}.pdf`;

    const paginators = document.querySelectorAll('.mat-mdc-paginator');
    const tableWrappers = document.querySelectorAll('.mat-table-wrapper');
    const tableOverflows = document.querySelectorAll('.table-overflow');
    const mainContainers = document.querySelectorAll('.container-fluid.main-container');

    paginators.forEach((el) => ((el as HTMLElement).style.display = 'none'));

    tableWrappers.forEach((el) => ((el as HTMLElement).style.overflow = 'visible'));
    tableOverflows.forEach((el) => {
      const h = el as HTMLElement;
      h.style.maxHeight = 'none';
      h.style.overflowX = 'visible';
      h.style.overflowY = 'visible';
    });

    mainContainers.forEach((el) => {
      const h = el as HTMLElement;
      h.style.top = '0';
      h.style.bottom = '0';
    });

    const target = this.containerGeral.nativeElement as HTMLElement;
    target.classList.add('export-pdf');

    // pega a largura real do container (incluindo parte que teria scroll)
    const containerWidth = target.scrollWidth || target.clientWidth;

    const opt = {
      margin: 10,
      html2canvas: {
        scale: 2,
        useCORS: true,
      },
      jsPDF: { format: 'a4', orientation: 'portrait' },
      pagebreak: {
        mode: ['css', 'avoid-all', 'legacy'],
      },
    };

    setTimeout(() => {
      html2pdf()
        .set(opt)
        .from(target)
        .save(pdfName)
        .then(() => {
          target.classList.remove('export-pdf');

          paginators.forEach((el) => ((el as HTMLElement).style.display = ''));
          tableWrappers.forEach((el) => ((el as HTMLElement).style.overflow = ''));
          tableOverflows.forEach((el) => {
            const h = el as HTMLElement;
            h.style.maxHeight = '';
            h.style.overflowX = '';
            h.style.overflowY = '';
          });
          mainContainers.forEach((el) => {
            const h = el as HTMLElement;
            h.style.top = '';
            h.style.bottom = '';
          });
        })
        .finally(() => {
          this.loading = false;
          this.imprimindoPDF = false;
        });
    }, 300);

    this.loading = false;
    this.imprimindoPDF = false;
  }

  async gerarEstimativas() {
    this.estimativaService.getById(this.estimativaId).subscribe((estimativa) => {
      this.estimativa = estimativa;
      this.nome = this.estimativa.nome;
      this.projetoId = this.estimativa.projetoId;
      this.podeEditar = this.estimativa.statusId !== 1;

      this.estimativaTipo = this.estimativa.estimativaTipoId;
      // Aprovar / Reprovar
      this.user = JSON.parse(localStorage.getItem('currentUserPricingWeb'));
      this.aprovarReprovar = this.estimativa.statusId === 4;

      this.projetoService.getById(this.projetoId).subscribe((result) => {
        this.projeto = result.nome;
        this.crm = result.crmId;
        this.clienteNome = result.cliente.nome;
        this.utilService.setMessage(result.cliente.nome);
        this.utilService.currentMessage.subscribe((message) => (result.cliente.nome = message));
      });

      this.equipeService.getByPropostaId(this.estimativaId).subscribe((result) => {
        this.qtdUser = result.count;
        this.podeEditar = this.estimativa.statusId === 2;
      });

      this.validacaoService.validarEnvioAprovacao(this.estimativaId).subscribe((result) => {
        this.enviarAprovacao =
          (result.resultado && this.estimativa.statusId === 1) ||
          (this.estimativa.estimativaTipoId === 2 && this.estimativa.statusId === 1 && this.qtdUser > 0);
        if (result.mensagem == null) {
          this.mensagemValidacao = 'Aprovar Proposta';
        } else {
          this.mensagemValidacao = result.mensagem + ' ' + result.objeto;
          console.log('result', result);
        }
      });

      this.estimativaService.retornarQuantidade(this.projetoId, this.estimativaId).subscribe((result) => {
        this.totalEstimativa = result;
      });
    });
  }

  aprovacaoReprovacao(statusId: number) {
    this.estimativa.statusId = statusId; // Enviada

    this.estimativaService.update(this.estimativa).subscribe(() => {
      this.voltar();
    });
  }

  voltar() {
    if (this.user.perfil[0].id === 1) {
      this.router.navigate(['price/projeto/estimativa-list/' + 0]);
    } else {
      this.router.navigate(['price/projeto/estimativa-list/' + 0]);
    }
  }

  editar() {
    this.router.navigate(['price/projeto/estimativa-edit/' + this.estimativaId]);
  }

  openComentario() {
    const dialogRef = this.dialog.open(ComentarioFormComponent, {
      width: '600px',
      height: '375px',
      data: {
        estimativaId: this.estimativaId,
      },
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  recalcular() {
    this.resetFormSubject.next(true);
  }

  // Modal de confirmação
  openConfirm(acao: string, byPass: boolean = false): void {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: '500px',
      data: {
        titulo: 'Atenção',
        conteudo: `Deseja realmente ${acao} a estimativa?`,
        acao,
        component: 'estimativa',
        totalEstimativa: this.totalEstimativa,
      },
      panelClass: 'default-dialog-container',
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data !== undefined) {
        if (data.statusId > 0) {
          this.estimativa.statusId = data.statusId;
          this.estimativaService.update(this.estimativa).subscribe(() => {
            if (this.totalEstimativa > 0 && data.statusId === 2) {
              this.estimativaService
                .descartarEstimativas(this.projetoId, this.estimativaId, this.utilService.getUserId())
                .subscribe();
            }

            if (data.mensagem !== '') {
              const comentario = new Comentario();
              comentario.estimativaId = this.estimativaId;
              comentario.mensagem = data.mensagem;
              comentario.usuarioId = this.utilService.getUserId();
              comentario.ativo = true;

              this.comentarioService.create(comentario).subscribe();
            }
            if (!byPass) this.router.navigate(['mesa-aprovacao']);
            else this.router.navigate(['price/usuario/estimativa/0']);
          });
        }
      }
    });
  }

  openEnviar(): void {
    const dialogRef = this.dialog.open(EstimativaAprovarFormComponent, {
      width: '600px',
      height: '425px',
      data: {
        estimativaId: this.estimativaId,
        projetoId: this.projetoId,
        byPassAprovacao: this.isAdmin,
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (this.isAdmin && data !== undefined && data.byPassAprovacao) {
        this.openConfirm('aprovar', true);
      }
    });
  }
}
